import React from "react";
import Chip from "../Chip";
import { grey } from "@mui/material/colors";
import MUIAvatar from "@mui/material/Avatar";
import Department from "../../Utility/Crud/Department";
import PropTypes from "prop-types";
import * as MUIColors from "@mui/material/colors";
import MainContext from "../../Context/MainContext/MainContext";

export default class ChipDepartment extends Chip {
  static contextType = MainContext; // For legacy class components

  /**
   * Renders a MUI Avatar.
   */
  renderAvatar() {
    const colorObject = this.props.department
      ? this.context.colorsIndexed[this.props.department.colorId]
      : null;
    const color = this.props.department
      ? MUIColors[colorObject.hue][colorObject.shade]
      : grey[500];
    const avatarColor = this.props.isTransparent ? "transparent" : color;
    const iconColor = this.props.isTransparent ? color : "#fff";

    return (
      <MUIAvatar sx={{ bgcolor: avatarColor }}>
        {Department.getIcon({ fontSize: "small", sx: { color: iconColor } })}
      </MUIAvatar>
    );
  }

  /**
   * @return {string} The department name.
   */
  getLabel() {
    return this.props.department
      ? Department.getDisplayName(this.props.department)
      : "None";
  }
}
